<!-- @veltra/icons generated sha256:7e3fc8da8ac04f05 gen:8 source:src/svg/normal/form-slider.svg -->
<script setup lang="ts">
defineOptions({ name: 'FormSlider' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path stroke="currentColor" stroke-linecap="round" stroke-width="1.2" d="M1.5 8h13" />
    <circle cx="6" cy="8" r="2.2" fill="currentColor" />
  </svg>
</template>
